import { Link } from "react-router";
import { publicRoutes } from "@/routing";

export const Footer = ({ showPrivacy = true }) => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="flex flex-row gap-4 text-sm/[22px] text-cm-p-text-secondary mb-2 items-end flex-1">
            <div>{`© ${currentYear} CargoMinds`}</div>
            {showPrivacy ? (
                <div>
                    <Link className="text-sm/[22px] text-cm-p-text-secondary" to={publicRoutes[2].path}>
                        Privacy
                    </Link>
                </div>
            ) : null}
        </div>
    );
};
